module.exports = __webpack_public_path__ + "static/media/group-12.664676c5.svg";